import { format, parseISO, addDays } from 'date-fns';

export default function formatPeriod(durationNumber, startPeriod) {
  const initial = format(parseISO(startPeriod), "dd'/'MM'/'yy")
  const period = format(addDays(parseISO(startPeriod), durationNumber), "dd'/'MM'/'yy");
  const stringPeriod = `${initial} à ${period}`
  return stringPeriod;
}